module.exports = __webpack_public_path__ + "static/media/5.f11a30f7.gif";